import { ItemGroupPreview } from "@dto/architecture.dto";
import { AdditionalPayload, ApiPrams, ruleHwType } from "../../XmRule";
import { RuleGroup } from "../../XmRuleList";
import { UsePreviewModal } from "./Preview";

type CgPreviewHandlerType = (
  cls: string,
  hwType: string | undefined,
  subsystem: string,
  showModal: ReturnType<UsePreviewModal>[0],
  additionalApiParams?: ApiPrams
) => (rules: RuleGroup[]) => () => void;

const cgPreviewHandler: CgPreviewHandlerType = (cls, hwType, subsystem, showModal, additionalApiParams = {}) => (rules) => () => {
  const regexNew: ItemGroupPreview[] = rules.map(({ items, tags, regex, parents, exclude }) => makePreviewApiData({ cls, hwType, subsystem, items, tags, regex, parents, exclude }));
  showModal({
    hw_type: hwType,
    subsystem,
    data: regexNew,
    additionalApiParams,
  });
};

interface RowData {
  cls: string;
  hwType?: string;
  subsystem: string;
  parents?: RuleGroup['parents'];
  regex?: string[];
  tags?: RuleGroup['tags'];
  exclude?: RuleGroup['exclude'];
  items?: RuleGroup['items'];
}

export function makePreviewApiData(
  {
    cls,
    hwType,
    subsystem,
    parents,
    regex,
    tags,
    exclude,
    items,
  }: RowData,
  linuxExclude = false,
  additionalPayload?: AdditionalPayload
): ItemGroupPreview {
  return {
    class: cls,
    hw_type: additionalPayload?.hw_type || ruleHwType(cls, hwType),
    subsystem,
    regex,
    tags: tags?.map(t => t.tag_id),
    linuxExclude,
    withDeleted: additionalPayload?.withDeleted,
    item_ids: items?.filter(item => !item.disabled).map(item => item.item_id),
    parents: parents && {
      intersection: parents.intersection,
      regex: parents.regex?.filter(parent => !!parent.subsystem),
      tags: parents.tags?.map(({ tag_id, subsystem }) => ({ tag_id, subsystem })),
      item_ids: parents.items?.map(item => item.item_id),
    },
    exclude: exclude && {
      regex: exclude.regex,
      tags: exclude.tags?.map(({ tag_id }) => tag_id),
      item_ids: exclude.items?.map(item => item.item_id),
    }
  };
}

export default cgPreviewHandler;